import { RecordingData } from "@/utils/indexedDBUtils";
import { createContext } from "react";

export type IndexDBContextType = {
  allRecordingUUIDs: string[];
  allRecordingData: RecordingData[];
  isOnIndexDB(recordingId: string): boolean;
  deleteFromIndexDB(items: string[]): Promise<void>;
  downloadAudioFromIndexedDB(recordingId: string): Promise<void>;
  updateState(): Promise<void>;
};

export const IndexDBContext = createContext<IndexDBContextType | null>(null);
